import type { PendingEvent, ActiveEvent } from '@/systems/EventManager';
import './styles.css';

export class EventPopup {
  private el: HTMLElement;
  private contentEl: HTMLElement;
  private iconEl: HTMLElement;
  private nameEl: HTMLElement;
  private timerEl: HTMLElement;
  private onTap: () => void;

  constructor(parent: HTMLElement, onTap: () => void) {
    this.onTap = onTap;

    this.el = document.createElement('div');
    this.el.className = 'event-popup';

    this.contentEl = document.createElement('div');
    this.contentEl.className = 'event-popup-content';

    this.iconEl = document.createElement('span');
    this.iconEl.className = 'event-icon';

    this.nameEl = document.createElement('span');
    this.nameEl.className = 'event-name';

    this.timerEl = document.createElement('span');
    this.timerEl.className = 'event-timer';

    this.contentEl.appendChild(this.iconEl);
    this.contentEl.appendChild(this.nameEl);
    this.contentEl.appendChild(this.timerEl);
    this.el.appendChild(this.contentEl);

    this.el.addEventListener('click', () => this.onTap());
    this.el.addEventListener('touchend', (e) => {
      e.preventDefault();
      this.onTap();
    });

    parent.appendChild(this.el);
  }

  showPending(event: PendingEvent): void {
    this.el.className = 'event-popup event-pending';
    this.el.style.display = 'block';

    this.iconEl.textContent = event.type.icon;
    this.nameEl.textContent = event.type.name;
    this.timerEl.textContent = `${Math.ceil(event.expiresIn)}s`;
  }

  showActive(event: ActiveEvent): void {
    this.el.className = 'event-popup event-active';
    this.el.style.display = 'block';

    this.iconEl.textContent = event.type.icon;
    this.nameEl.textContent = event.type.name;
    this.timerEl.textContent = `${Math.ceil(event.remainingSeconds)}s`;
  }

  hide(): void {
    this.el.style.display = 'none';
    this.el.className = 'event-popup';
  }

  destroy(): void {
    this.el.remove();
  }
}
